import { action, extendObservable, reaction } from "mobx";

class ResetDigitalTicketsStore {
  constructor(authStore, commonStore, compTixApi, routerStore, loadingStore, alertStore, eventReservationsStore) {
    this.authStore = authStore;
    this.commonStore = commonStore;
    this.compTixApi = compTixApi;
    this.routerStore = routerStore;
    this.loadingStore = loadingStore;
    this.eventReservationsStore = eventReservationsStore;

    this.defaults = {
      selectedUserId: -1,
      selectedRequestId: -1,
      forwardId: "",
      showResetTicketsModal: false,
      showParkingPasses: false,
      gamePk: null,
      request: {},
      requestId: -1,
      allTickets: [],
      parkingPasses: [],
      selectedTickets: [],
      digitalTicketDelivery: null
    };

    extendObservable(this, {
      selectedRequestId: this.defaults["selectedRequestId"],
      showResetTicketsModal: this.defaults["showResetTicketsModal"],
      gamePk: this.defaults["gamePk"],
      request: this.defaults["request"],
      requestId: this.defaults["requestId"],

      setSelectedRequestId: action(selectedRequestId => {
        this.selectedRequestId = selectedRequestId;
      }),
      setShowResetTicketsModal: action(value => {
        this.showResetTicketsModal = value;
      }),
      setGamePk: action(value => {
        this.gamePk = value;
      }),
      setRequest: action(value => {
        this.request = value;
      }),
      setRequestId: action(value => {
        this.requestId = value;
      })
    });

    reaction(
      () => this.showResetTicketsModal,
      () => {
        if (this.showResetTicketsModal && this.requestId) {
          this.compTixApi.getTicketRequest(this.requestId).then(data => {
            this.setRequest(data);
          });
        }
      }
    );
  }

  resetTickets = () => {
    this.loadingStore.setLoading(true);
    this.compTixApi.resetDigitalTickets(this.requestId).then(data => {
      this.setShowResetTicketsModal(false);
      this.eventReservationsStore.setSelectedReservations([]);
      this.eventReservationsStore.getReservations();
      this.loadingStore.setLoading(false);
    });
  };
}

export default ResetDigitalTicketsStore;
